var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card" },
    [
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ valid }) {
              return [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.user
                            ? _vm.$t("customer.scan_users.edit_user")
                            : _vm.$t("customer.scan_users.create_user")
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("global.name") } },
                      [
                        _c("ValidationProvider", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        name: "name",
                                        type: "text",
                                        pattern: "[a-zA-Z0-9 ]+",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.userToEdit.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userToEdit, "name", $$v)
                                        },
                                        expression: "userToEdit.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: _vm.$t("customer.scan_users.code") } },
                      [
                        _c("ValidationProvider", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ errors }) {
                                  return [
                                    _c("b-input", {
                                      attrs: {
                                        name: "code",
                                        type: "text",
                                        pattern: "[a-zA-Z0-9 ]+",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.userToEdit.code,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.userToEdit, "code", $$v)
                                        },
                                        expression: "userToEdit.code",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "is-primary button is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting || _vm.loading },
                      attrs: { disabled: !valid, type: "submit" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }